import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { ElectricMeter } from '@shared/models/electric-meter';

@Component({
    selector: 'bcm-electric-meter-link',
    templateUrl: './electric-meter-link.component.html',
    standalone: false
})
export class ElectricMeterLinkComponent implements OnChanges {

    @Input()
    public electricMeter!: ElectricMeter;

    @Input()
    public dataTest: string;

    @Input()
    public additionalInfo: string;

    @Input()
    public disableLink: boolean;

    @Input()
    public showCabinet = false;

    /** When true, link opens the meter readings list instead of the meter detail. */
    @Input()
    public linkToReadings = false;

    public viewData: string;

    @Output()
    public clicked = new EventEmitter<void>();

    ngOnChanges(): void {
        const electricMeter = this.electricMeter;
        this.viewData = [
            this.showCabinet && electricMeter?.cabinet?.handle && electricMeter?.cabinet?.handle || null,
            (electricMeter?.handle?.includes('Anschluss') ? electricMeter?.handle : `Anschluss: ${electricMeter?.handle}`) || null,
            this.additionalInfo,
        ].filter(item => item != null)
            .join(' - ');
    }

    click(event): void {
        this.clicked.emit();
        event.stopPropagation();
    }
}
